import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { setActiveTab } from '@actions/data-detail-actions';
import OverflowTooltip from '@shared/overflow-tooltip';
import './tab.scss';

// A vertical tab component that scrolls into the specified id when a
// tab is selected.
const Tab = ({ dataType, id, label }) => {
  const dispatch = useDispatch();
  const currentTab = useSelector(state => state.dataDetail.currentTab[dataType]);

  const isSelected = currentTab === id;

  // Scroll to the tab section when this tab becomes selected
  const scrollOnSelection = useCallback(() => {
    if (isSelected) {
      const titleElement = document.getElementById(`tab-section-${id}-title`);
      if (titleElement) {
        titleElement.scrollIntoView();
      }
    }
  }, [id, isSelected]);

  // Scroll on mount if selected
  useEffect(() => {
    scrollOnSelection();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Scroll when currentTab changes and this tab becomes selected
  useEffect(() => {
    scrollOnSelection();
  }, [currentTab, scrollOnSelection]);

  const onClick = useCallback(() => {
    dispatch(setActiveTab(dataType, id));
    // The Redux state update will trigger a re-render and
    // the useEffect above will handle scrolling
  }, [dataType, dispatch, id]);

  return (
    <div onClick={onClick}
      role="presentation"
      id={`tab-section-${id}-option-item`}
      styleName="tab-container"
    >
      <OverflowTooltip>{label}</OverflowTooltip>
    </div>
  );
};

Tab.propTypes = {
  dataType: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string
};

export default Tab;
